import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { setRedirectUrlAction } from '../../store/actions/user.action';
import { Language } from 'vidis-common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({providedIn: 'root'})
export class RoutingService {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly translate: TranslateService  = inject(TranslateService);
  private readonly store: Store = inject(Store);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  readonly routingLanguage = signal<string>(undefined);

  initRouting(): void {
    this.setInitialLanguage();
    this.setupQueryParamHook();
  }

  setInitialLanguage(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(queryParams => {
      const langFromParams = queryParams.get('lang');
      const langFromStorage = localStorage.getItem('lang');
      const browserLang = window.navigator.language;
      let selectedLang = langFromParams || langFromStorage || (Object.values(Language).includes(browserLang as Language) ? browserLang.toLowerCase() : 'nl');

      if (langFromParams && langFromParams !== langFromStorage) {
        localStorage.setItem('lang', langFromParams);
      }
      this.routingLanguage.set(selectedLang);
      this.translate.setDefaultLang(selectedLang);
      this.translate.use(selectedLang);
    });
  }

  setupQueryParamHook(): void {
    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(queryParams => {
        if (queryParams.get('redirect')) {
          this.store.dispatch(setRedirectUrlAction({
            url: queryParams.get('redirect')
          }));
        }
      });
  }
}
